import { Button, Card, CardBody, Col, CardHeader, Container, Form, FormGroup, Input, Label, Row, Table, CardFooter, Media } from "reactstrap";
import { Btn, H4, Image, LI, P, UL, Badges, H3, H5, SVG, H1, Alerts } from "../../AbstractElements";
import { URL_API } from "../../utils/helper/helpers";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import useFourListe from "../Fournisseurs/FourApi";
import { ActualFileUpload, DropFileUploadText, DropFilesHereOrClickToUpload, UploadProjectFiles } from '../../utils/Constant';
import { Dropzone, FileMosaic, ExtFile } from "@dropzone-ui/react";
import { H6 } from '../../AbstractElements';
import useInfosEts from "../InfosEts/InfoApi";
import SweetAlert from 'sweetalert2';

type Fours = { [key: string]: any }

const AddVersementCimaf = ({ id_fournisseur, type }: { id_fournisseur: number, type: string }) => {

    const Token = JSON.parse(localStorage.getItem("login")!);
    const [refresh, setRefresh] = useState(false);
    const navigate = useNavigate();
    // const fournis = useFourListe(refresh) || [];
    const infosEts = useInfosEts(refresh) || [];
    const updateFiles = (incomingFiles: ExtFile[]) => {
        setData((prevState) => ({
            ...prevState,
            file: incomingFiles,
            recu: incomingFiles[0]?.file || null,
        }));
    };
    const removeFile = (id: string | number | undefined) => {
        setData((prevState) => ({
            ...prevState,
            file: data.file.filter((x: ExtFile) => x.id !== id),
            recu: null
        }));
    };

    const [data, setData] = useState({
        montant: '',
        // materiel: '',
        // quantite_tonne: 0,
        // quantite_sac: 0,
        mode_payment: '',
        num_paiement: '',
        date_versement: '',
        idfournisseur: id_fournisseur,
        selectType: type,
        idinfos: null,
        recu: null as File | null,
        file: [] as ExtFile[],
        id: null
    });
    const [erreur, setErreur] = useState({
        montant: '',
        // materiel: '',
        // quantite_tonne: '',
        // quantite_sac: '',
        mode_payment: '',
        num_paiement: '',
        date_versement: '',
        idfournisseur: null,
        idinfos: null,
        recu: [] as ExtFile[],
        id: null
    });



    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;

        const formatMontant = (valeur: string) => {
            // Supprime tout sauf les chiffres
            const montantNettoye = valeur.replace(/[^\d]/g, '');

            // Formate le montant avec des espaces tous les trois chiffres
            return montantNettoye.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        };

        // Si le champ modifié est le montant, appliquez le formatage
        const formattedValue = name === "montant" ? formatMontant(value) : value;

        setData((prevState) => ({
            ...prevState,
            [name]: formattedValue
        }));
    };

    useEffect(() => {

        setData((prevState) => ({
            ...prevState,
            idfournisseur: id_fournisseur,
            selectType: type
        }));
    }, [id_fournisseur, type]);

    const handleSubmitData = (e: React.FormEvent) => {
        e.preventDefault();

        SweetAlert.fire({
            title: 'Informations',
            text: " Les données doivent être envoyé et ne peuvent pas être modifiées ou supprimées !",
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, Envoyer'
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post(`${URL_API}/versement/store`, { ...data }, {
                    headers: {
                        Authorization: `Bearer ${Token}`,
                        'Content-Type': 'multipart/form-data',
                    }
                }).then(response => {
                    if (response.data.success) {
                        const msg = "Versement ajouté avec succès !!";
                        toast.success(msg);
                        clearDataForm();
                    }

                }).catch(error => {
                    toast.info("Oups !! Erreur de modification des données");
                    if (error.response && error.response.data.success === false) {
                        const newErrors = error.response.data.message;
                        setErreur(prevErrors => ({
                            ...prevErrors,
                            ...newErrors,
                        }));
                    }
                })
            } else {
                toast.info('Vueillez renseigner tous les champs')
            }

        });

    }

    const clearDataForm = () => {
        setData({
            montant: '',
            mode_payment: '',
            num_paiement: '',
            date_versement: '',
            idinfos: null,
            idfournisseur: id_fournisseur,
            selectType: type,
            recu: null as File | null,
            file: [] as ExtFile[],
            id: null
        });
        setErreur({
            montant: '',
            mode_payment: '',
            num_paiement: '',
            date_versement: '',
            idinfos: null,
            idfournisseur: null,
            recu: [] as ExtFile[],
            id: null
        });
        navigate('/gestion-versements')
    }

    return (
        <div className='page-body'>
            <Container fluid>
                <Card>
                    <CardBody>
                        <Form onSubmit={handleSubmitData}>
                            <H1 className="mb-2 text-capitalize text-center">
                                Ciments de l'afrique (CIMAF)
                            </H1>

                            <div className="product-info">
                                <div className="product-group">
                                    <Row>
                                        <Col sm="6">
                                            <FormGroup>
                                                <Label>Etablissement</Label>
                                                <Input
                                                    placeholder="Entrer le type"
                                                    name="idinfos"
                                                    value={data.idinfos || ''}
                                                    onChange={changeHandler}
                                                    type="select"
                                                    className="form-control"
                                                >
                                                    <option value=''>Sélectionner...</option>
                                                    {infosEts.map((item, index) => {
                                                        if (item.status === 'actif' && item.type === 'Personnel') {
                                                            return <option key={index} value={item.id}>{item.nom}</option>;
                                                        }
                                                        return null;
                                                    })}
                                                </Input>
                                                {erreur.idinfos && (
                                                    <span className="text-danger">{erreur.idinfos}</span>
                                                )}
                                            </FormGroup>
                                        </Col>
                                        <Col sm="6">
                                            <FormGroup>
                                                <Label>Mode de payement</Label>
                                                <Input
                                                    placeholder="Entrer le type"
                                                    name="mode_payment"
                                                    value={data.mode_payment || ''}
                                                    onChange={changeHandler}
                                                    type="select"
                                                    className="form-control"
                                                >
                                                    <option value=''>Sélectionner...</option>
                                                    <option value='Chèque'>Chèque</option>
                                                    <option value='Espèce'>Espece ou Liquide</option>
                                                    <option value='Virement Bancaire'>Virement Bancaire</option>
                                                </Input>
                                                {erreur.mode_payment && (
                                                    <span className="text-danger">{erreur.mode_payment}</span>
                                                )}
                                            </FormGroup>
                                        </Col>
                                        <Col sm="6">
                                            <FormGroup>
                                                <Label>Montant</Label>
                                                <Input
                                                    placeholder="Entrer le montant"
                                                    name="montant"
                                                    value={data.montant}
                                                    onChange={changeHandler}
                                                    type="text"
                                                />
                                                {erreur.montant && (
                                                    <span className="text-danger">{erreur.montant}</span>
                                                )}
                                            </FormGroup>
                                        </Col>
                                        <Col sm="6">
                                            <FormGroup>
                                                <Label>Numéro de paiement</Label>
                                                <Input
                                                    placeholder="Entrer le code de versement"
                                                    name="num_paiement"
                                                    value={data.num_paiement}
                                                    onChange={changeHandler}
                                                    type="text"
                                                />
                                                {erreur.num_paiement && (
                                                    <span className="text-danger">{erreur.num_paiement}</span>
                                                )}
                                            </FormGroup>
                                        </Col>
                                        <Col sm="12">
                                            <FormGroup>
                                                <Label>Date de versement</Label>
                                                <Input
                                                    placeholder="Entrer le quantité sac"
                                                    name="date_versement"
                                                    value={data.date_versement}
                                                    onChange={changeHandler}
                                                    type="date"
                                                />
                                                {erreur.date_versement && (
                                                    <span className="text-danger">{erreur.date_versement}</span>
                                                )}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Label check>Importer le justificatif</Label>
                                                <Dropzone onChange={updateFiles} value={data.file} maxFiles={1} header={false} footer={false} minHeight="80px" label="Drag'n drop files here or click to Browse">
                                                    {data.file.map((file: ExtFile) => (
                                                        <FileMosaic key={file.id} {...file} onDelete={removeFile} info={true} />
                                                    ))}
                                                    {data.file.length === 0 && (
                                                        <div className="dz-message needsclick p-5">
                                                            <i className="icon-cloud-up font-primary"></i>
                                                            <H6>{DropFilesHereOrClickToUpload}</H6>
                                                            <span className="note needsclick">
                                                                {DropFileUploadText}<strong>not</strong>{ActualFileUpload}
                                                            </span>
                                                        </div>
                                                    )}
                                                </Dropzone>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className="text-end">
                                <Btn color="info" type="submit">Ajouter</Btn>
                                <Btn className="btn btn-danger ms-3" onClick={() => clearDataForm()}>Annuler</Btn>
                            </div>
                        </Form>
                    </CardBody>

                </Card>

            </Container>
        </div>
    )
}

export default AddVersementCimaf;